module.exports = __webpack_public_path__ + "static/img/002.0f86a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/002.png
// module id = caoy
// module chunks = 1